import { createFileRoute } from '@tanstack/react-router';
import { JourneysWarehouseConfigHandoff } from '@/pages/workspaces/integrations/warehouse/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/integrations/warehouse/:type` URL. Flag off it renders the embedded Ember
 * host; flag on it forwards to the migrated URL.
 *
 * The resolver is required, not decorative: ownership claims the `/workspaces/last` form of this
 * URL, so the embedded app — which would otherwise resolve the sentinel itself — never mounts to do
 * it, and the handoff has no workspace id to forward to.
 */
function JourneysWarehouseConfigRoute() {
  const { type } = Route.useParams();

  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysWarehouseConfigHandoff type={type} />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/$type')({
  component: JourneysWarehouseConfigRoute,
});
